module.exports = __webpack_public_path__ + "static/media/agreeDhip.57de4816.png";